function normalizeFilename(value) {
  if (typeof value !== "string") {
    return "";
  }

  return value
    .trim()
    .replaceAll("\\", "_")
    .replaceAll("/", "_");
}


export function filenameFromContentDisposition(
  contentDisposition,
) {
  if (typeof contentDisposition !== "string") {
    return "";
  }

  const utf8Match = contentDisposition.match(
    /filename\*=UTF-8''([^;]+)/i,
  );

  if (utf8Match?.[1]) {
    try {
      return normalizeFilename(
        decodeURIComponent(
          utf8Match[1].trim().replace(/^["']|["']$/g, ""),
        ),
      );
    } catch {
      return normalizeFilename(
        utf8Match[1].trim().replace(/^["']|["']$/g, ""),
      );
    }
  }

  const filenameMatch = contentDisposition.match(
    /filename\s*=\s*(?:"([^"]+)"|'([^']+)'|([^;]+))/i,
  );

  return normalizeFilename(
    filenameMatch?.[1]
    || filenameMatch?.[2]
    || filenameMatch?.[3]
    || "",
  );
}


export function downloadBlob(
  blob,
  filename,
  {
    urlApi = globalThis.URL,
    documentApi = globalThis.document,
  } = {},
) {
  if (!(blob instanceof Blob)) {
    throw new TypeError(
      "blob must be a Blob instance.",
    );
  }

  const normalizedFilename = normalizeFilename(
    filename,
  );

  if (!normalizedFilename) {
    throw new TypeError(
      "filename must be a non-empty string.",
    );
  }

  if (
    !urlApi?.createObjectURL
    || !urlApi?.revokeObjectURL
    || !documentApi?.createElement
  ) {
    throw new Error(
      "Browser download APIs are unavailable.",
    );
  }

  const objectUrl = urlApi.createObjectURL(blob);
  const link = documentApi.createElement("a");

  link.href = objectUrl;
  link.download = normalizedFilename;
  link.style.display = "none";

  documentApi.body.appendChild(link);

  try {
    link.click();
  } finally {
    link.remove();
    urlApi.revokeObjectURL(objectUrl);
  }

  return normalizedFilename;
}


export default downloadBlob;
